import { getPath } from '@/router/common'

const baseUrl = {
  title: '扫码支付',
  path: 'Pay'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'pay_index',
    component: () => import(/* webpackChunkName: "pay_index" */ '@/views/pay/index/index.vue'),
    meta: {
      title: '扫码支付收银台'
    }
  },
  {
    path: getPath('Detail', baseUrl),
    name: 'Pay_Detail',
    component: () => import(/* webpackChunkName: "Pay_Detail" */ '@/views/pay/detail/index.vue'),
    meta: {
      title: '扫码收款明细'
    }
  },
  {
    path: getPath('ListDetail', baseUrl),
    name: 'ListDetail',
    component: () => import(/* webpackChunkName: "ListDetail" */ '@/views/pay/listDetail/index.vue'),
    meta: {
      title: '扫码收款明细'
    }
  },
]
